import {useSelector} from 'react-redux';
import CbgReportTemplate from '../Components/CbgReportTemplate';
import PrescriptionTemplate_temp from '../Components/PrescriptionTemplate_temp';
import RilReportTemplate from '../Components/RilReportTemplate';
import RilReportTemplateTwo from '../Components/RilReportTemplateTwo';
import RplTemplate from '../Components/RplTemplate';
import '../styles/Prescription.scss';
import DeliveryAdmissionFormormTemplate from '../template/daf/DAF';
import DeliveryEssentialsTemplate from '../template/delivery essentials/delivery_essentials';
import Reportscreatepage from './Reportscreatepage';

import SecondMonthPregnancy from '../moretemplates/2nd Month Pregnancy/secondMonthPregnancy';
import ThirdMonthPregnancy from '../moretemplates/3rd Month Pregnancy/thirdMonthPregnancy';
import FourthMonthICSI from '../moretemplates/4thMonthICSI/FourthMonthICSI';
import FourthMonthPregnancy from '../moretemplates/4thMonthPregnancy/FourthMonthPregnancy';
import FifthMonthICSI from '../moretemplates/5thMonthICSI/FifthMonthICSI';
import FifthMonthPregnancy from '../moretemplates/5thMonthPregnancy/FifthMonthPregnancy';
import SixthMonthICSI from '../moretemplates/6thMonthICSI/SixthMonthICSI';
import SixthMonthPregnancy from '../moretemplates/6thMonthPregnancy/SixthMonthPregnancy';
import SeventhMonthICSI from '../moretemplates/7thMonthICSI/SeventhMonthICSI';
import SeventhMonthPregnancy from '../moretemplates/7thMonthPregnancy/SeventhMonthPregnancy';
import EighthMonthICSI from '../moretemplates/8thMonthICSI/EighthMonthICSI';
import EighthMonthPregnancy from '../moretemplates/8thMonthPregnancy/EighthMonthPregnancy';
import NinthMonthICSI from '../moretemplates/9thMonthICSI/NinthMonthICSI';
import NinthMonthPregnancy from '../moretemplates/9thMonthPregnancy/NinthMonthPregnancy';
import AnChart from '../moretemplates/AN CHART/AnChart';
import ArtSummary from '../moretemplates/ArtSummary/ArtSummary';
import BookingVisit from '../moretemplates/Booking visit/BookingVisit';
import BPChart from '../moretemplates/BP CHART/BPChart';
import BpSugarChart from '../moretemplates/BP SUGAR CHART/bp_sugar_chart';
import DonorStimulationCheckList from '../moretemplates/DonorStimulationCheckList/DonorStimulationCheckList';
import EditPrescription from '../moretemplates/Edit Prescription/EditPrescription';
import Egg from '../moretemplates/egg_collection_instructions/egg_collection_instructions';
import EmptyTemplate from '../moretemplates/EmptyTemplate/EmptyTemplate';
import EtTemplate from '../moretemplates/ET template/et_template';
import FertilityFirstVisit from '../moretemplates/Fertility first visit/FertilityFirstVisit';
import HeavyBleedingTemplates from '../moretemplates/HEAVY BLEEDING Template Date/heavy_bleeding_template_date';
// import HRTChart from '../moretemplates/HrtChart/HRTChart';
import HrtCheckListMeds from '../moretemplates/HRT CheckList Meds/HrtChecklistMeds';
import HRTListChart from '../moretemplates/HrtCheckListAndChart/HRTListChart';
import HRTChart from '../moretemplates/HrtChart/HRTChart';
import IcsiDetails from '../moretemplates/ICSI Details/IcsiDetails';
import ICSI2ndMonth from '../moretemplates/ICSI2ndMonth/ICSI2ndMonth';
import ICSI2ndMonth1stScan from '../moretemplates/ICSI2ndMonth/ICSI2ndMonth1stScan';
import ICSI2ndMonth8WeeksScan from '../moretemplates/ICSI2ndMonth/ICSI2ndMonth8WeeksScan';
import ICSI2ndMonth10WeeksScan from '../moretemplates/ICSI2ndMonth/ICSI2ndMonth10WeeksScan';
import ICSI3rdMonth from '../moretemplates/ICSI3rdMonth/ICSI3rdMonth';
import InjectionChart from '../moretemplates/Injection chart/injection_chart';
import InjectionPriceTemplate from '../moretemplates/Injection Price Template/InjectionPriceTemplate';
import IrregularPeriodTemplate from '../moretemplates/IRREGULAR PERIOD Template Date/IrregularPeriod';
import Iui from '../moretemplates/IUI/iui';
import IUIChart from '../moretemplates/IUIChart/IUIChart';
import KickCountChart from '../moretemplates/KICK COUNT CHART/KickCountChart';
import LutealSupport from '../moretemplates/LUTEAL SUPPORT MEDICATIONS/luteal_support_medications';
import Mtp from '../moretemplates/MTP/mtp';
import NcHrt from '../moretemplates/NC HRT/nc_hrt';
import NegativeIVFCycleAnalysis from '../moretemplates/NegativeIVFCycleAnalysis/NegativeIVFCycleAnalysis';
import OITIChart from '../moretemplates/OITIChart/OITIChart';
import PlanningSummary from '../moretemplates/PlanningSummary/PlanningSummary';
import PositivePrescriptionAdvanced from '../moretemplates/PositivePrescriptionAdvanced/PositivePrescriptionAdvanced';
import PositivePrescriptionBasic from '../moretemplates/PositivePrescriptionBasic/PositivePrescriptionBasic';
import PostEggCollectionPrescription from '../moretemplates/Post Egg Collection Instruction/PostEggCollectionPrescription';
import PostIUISheet from '../moretemplates/Post IUI Sheet/PostIUISheet';
import PostP4EraMeds from '../moretemplates/POST P4 ERA MEDS/PostP4EraMeds';
import PostP4PrescriptionTemplate from '../moretemplates/POSTP4/PostPrescription';
import PreOPCheckList from '../moretemplates/PreOPCheckList/PreOPCheckList';
import PretermLabour from '../moretemplates/PRETERM LABOUR WORKUP/PretermLabour';
import ScanModule from '../moretemplates/Scan Module/ScanModule';
import RplWorkUp from '../moretemplates/RPL WorkUp/RplWorkUp';
import ScFetStimulatedTemplate from '../moretemplates/ScFetStimulatedCycle/ScFetStimulated';
import StimulationTemplate from '../moretemplates/StimulationTemplate/StimulationTemplate';
import UtiTemplate from '../moretemplates/UTI Template Date/uti_template_date';
import DrugChart from '../template/drug_chart/drug_chart';
import FollicularMonitoring from '../template/follicular_monitoring/follicular_monitoring';
import Hrt from '../template/HRT/hrt';
import MonthWiseReview from '../template/MONTH WISE REVIEW IVF/month_wise_review_ivf';
import DrugCmonthWiseReview from '../template/month_wise_review_spontaneous_conception/month_wise_review_spontaneous_conception';
import NtScanIvf from '../template/NT SCAN IVF/nt_scan_ivf';
import NtSpontaneous from '../template/NT SPONTANEOUS/nt_spontaneous';
import PostNatal from '../template/post natal/post_natal';
import PriceList from '../template/Price list injections/price_list_injections';
import Whitedischarge from '../template/White discharge Template Date/white_discharge_template_date';

function Prescription(props) {
  const sideactive = useSelector(state => state.counter.sidebarnav);
  const prescriptionType = useSelector(state => state.counter.prescriptionType);
  const patientId = useSelector(state => state.counter.patientid);
  const patientsData = useSelector(state => state.counter.patientsData);
  console.log(patientsData, 'patientsData');

  return (
    <>
      <div className={sideactive ? 'maincontainer-patient-sa' : 'maincontainer-patient'}>
        <div className='patient-header'>
          <div className='row'>
            <div className='col'>
              <h3 className='page-title'>{prescriptionType}</h3>
              <ul className='breadcrumb'>
                <li className='breadcrumb-item'>
                  <a href='/' style={{textDecoration: 'none', color: 'black'}}>
                    Dashboard /
                  </a>
                  <a href='/Patients' style={{textDecoration: 'none', color: 'black'}}>
                    &nbsp;Patient
                  </a>
                </li>
                <li className='breadcrumb-item active'>Prescription</li>
              </ul>
            </div>
          </div>
          {/* <div style={{ width: "595px" }}> */}
          {prescriptionType === 'First Trimester' && (
            <PrescriptionTemplate_temp loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'RPL Report' && (
            <RplTemplate loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'RIL Report' && (
            <RilReportTemplate loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'RIL Report-2' && (
            <RilReportTemplateTwo loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'CBG Report' && (
            <CbgReportTemplate loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'DFI Report' && (
            <Reportscreatepage loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'IUI Report' && (
            <CbgReportTemplate loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Delivery Admission Form' && (
            <DeliveryAdmissionFormormTemplate loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}

          {prescriptionType === 'DeliveryEssentials' && (
            <DeliveryEssentialsTemplate loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}

          {prescriptionType === 'Drug Chart' && (
            <DrugChart loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Follicular Monitoring' && (
            <FollicularMonitoring loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'HRT' && <Hrt loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />}
          {prescriptionType === 'Month Wise Review Ivf' && (
            <MonthWiseReview loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Month Wise Review Spontaneous Conception' && (
            <DrugCmonthWiseReview loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'NT SCAN IVF' && (
            <NtScanIvf loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'NT Spontaneous' && (
            <NtSpontaneous loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Post Natal' && (
            <PostNatal loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Price List Injections' && (
            <PriceList loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'White discharge Template Date' && (
            <Whitedischarge loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}

          {prescriptionType === 'Booking Visit' && (
            <BookingVisit loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}

          {prescriptionType === 'Egg Collection Instructions' && (
            <Egg loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'ET Template' && (
            <EtTemplate loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Fertility First Visit' && (
            <FertilityFirstVisit loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}

          {prescriptionType === 'Heavy Bleeding Template Date' && (
            <HeavyBleedingTemplates loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Injection Chart' && (
            <InjectionChart loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}

          {prescriptionType === 'Irregular Periods' && (
            <IrregularPeriodTemplate loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Spontaneous Pregnancy - 2 Month' && (
            <SecondMonthPregnancy loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Spontaneous Pregnancy - 3 Month' && (
            <ThirdMonthPregnancy loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Spontaneous Pregnancy - 4 Month' && (
            <FourthMonthPregnancy loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Spontaneous Pregnancy - 5 Month' && (
            <FifthMonthPregnancy loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Spontaneous Pregnancy - 6 Month' && (
            <SixthMonthPregnancy loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Spontaneous Pregnancy - 7 Month' && (
            <SeventhMonthPregnancy loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Spontaneous Pregnancy - 8 Month' && (
            <EighthMonthPregnancy loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Spontaneous Pregnancy - 9 Month' && (
            <NinthMonthPregnancy loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'IUI' && <Iui loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />}
          {prescriptionType === 'Luteal Support Medications' && (
            <LutealSupport loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'MTP' && <Mtp loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />}
          {prescriptionType === 'Pre OP Check List' && (
            <PreOPCheckList loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'NC HRT' && (
            <NcHrt loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'OI TIC' && (
            <OITIChart loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'UTI Template Date' && (
            <UtiTemplate loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Empty Page' && (
            <EmptyTemplate loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Edit Prescription' && (
            <EditPrescription loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'ICSI Details' && (
            <IcsiDetails loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'HRT Checklist Meds' && (
            <HrtCheckListMeds loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Post P4 Era Meds' && (
            <PostP4EraMeds loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Planning Summary' && (
            <PlanningSummary loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {/* {prescriptionType === 'HRT Chart' && ( 
            <HrtChart loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}*/}
          {prescriptionType === 'Post Egg Collection Prescription' && (
            <PostEggCollectionPrescription loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}

          {prescriptionType === 'RPL Workup' && (
            <RplWorkUp loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Post P4 Prescription' && (
            <PostP4PrescriptionTemplate loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'SC-FET Stimulated Cycle' && (
            <ScFetStimulatedTemplate loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'HRT Chart' && (
            <HRTChart loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'HRT Check List' && (
            <HRTListChart loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Stimulation Template' && (
            <StimulationTemplate loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Post IUI Sheet' && (
            <PostIUISheet loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Injection Price' && (
            <InjectionPriceTemplate loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Positive Prescription Basic' && (
            <PositivePrescriptionBasic loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Positive Prescription Advanced' && (
            <PositivePrescriptionAdvanced loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'ART Summary' && (
            <ArtSummary loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'ICSI 2 nd month(1 st Scan)' && (
            <ICSI2ndMonth1stScan loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'ICSI 2 nd month(8 Weeks Scan)' && (
            <ICSI2ndMonth8WeeksScan loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'ICSI 2 nd month(10 Weeks Scan)' && (
            <ICSI2ndMonth10WeeksScan loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}

          {prescriptionType === 'ICSI 3 rd Month' && (
            <ICSI3rdMonth loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'ICSI 4 th Month' && (
            <FourthMonthICSI loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'ICSI 5 th Month' && (
            <FifthMonthICSI loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'ICSI 6 th Month' && (
            <SixthMonthICSI loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'ICSI 7 th Month' && (
            <SeventhMonthICSI loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'ICSI 8 th Month' && (
            <EighthMonthICSI loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'ICSI 9 th Month' && (
            <NinthMonthICSI loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Negative IVF Cycle Analysis' && (
            <NegativeIVFCycleAnalysis loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'IUI Chart' && (
            <IUIChart loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
         
          {prescriptionType === 'Preterm Labour' && (
            <PretermLabour loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
          {prescriptionType === 'Scan Module' && (
            <ScanModule loaderchange={props.loaderchange} patientId={patientId} patientsData={patientsData.data} popupalert={props.popupalert} popuptext={props.popuptext} />
          )}
        </div>
      </div>
    </>
  );
}

export default Prescription;
